import { FaPlus, FaSearch } from "react-icons/fa";
import "./ProvisionToolbar.css";

function ProvisionToolbar({
  search,
  setSearch,
  category,
  setCategory,
  onAdd,
}) {
  return (
    <div className="provision-toolbar">

      <div className="toolbar-left">

        <div className="search-box">
          <FaSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="All">All Categories</option>

          <option value="Rice">Rice</option>
          <option value="Atta">Atta</option>
          <option value="Dal">Dal</option>
          <option value="Oil">Oil</option>
          <option value="Sugar">Sugar</option>
          <option value="Salt">Salt</option>
          <option value="Spices">Spices</option>
          <option value="Masala">Masala</option>
          <option value="Tea">Tea</option>
          <option value="Coffee">Coffee</option>
          <option value="Dry Fruits">Dry Fruits</option>
          <option value="Biscuits">Biscuits</option>
          <option value="Snacks">Snacks</option>
          <option value="Soft Drinks">Soft Drinks</option>
          <option value="Dairy">Dairy</option>
          <option value="Frozen">Frozen</option>
          <option value="Cleaning">Cleaning</option>
          <option value="Personal Care">Personal Care</option>
          <option value="Baby Care">Baby Care</option>
          <option value="Pet Food">Pet Food</option>
          <option value="Others">Others</option>
        </select>

      </div>

      <button
        className="add-product-btn"
        onClick={onAdd}
      >
        <FaPlus />
        Add Product
      </button>

    </div>
  );
}

export default ProvisionToolbar;